var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRupeesSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 16,
    viewBox: "0 0 9 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6625 3.50019C8.84888 3.50019 9 3.34908 9 3.16269V2.0377C9 1.85131 8.84888 1.7002 8.6625 1.7002H0.3375C0.151116 1.7002 0 1.85131 0 2.0377V3.29623C0 3.48262 0.151116 3.63373 0.3375 3.63373H2.736C3.50404 3.63373 4.09334 3.9138 4.45078 4.40019H0.3375C0.151116 4.40019 0 4.55131 0 4.73769V5.86269C0 6.04908 0.151116 6.20019 0.3375 6.20019H4.80254C4.62769 7.21511 3.87551 7.84922 2.7 7.84922H0.3375C0.151116 7.84922 0 8.00033 0 8.18672V9.67768C0 9.77187 0.039375 9.86179 0.108591 9.92569L4.75068 14.2107C4.81302 14.2682 4.89475 14.3002 4.97959 14.3002H7.30164C7.60888 14.3002 7.75631 13.9231 7.53055 13.7147L3.287 9.79755C5.43853 9.73174 6.97542 8.29582 7.17719 6.20019H8.6625C8.84888 6.20019 9 6.04908 9 5.86269V4.73769C9 4.55131 8.84888 4.40019 8.6625 4.40019H7.01184C6.9138 4.0756 6.77897 3.77453 6.61101 3.50019H8.6625Z",
    fill: "#808282"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRupeesSign);
export default __webpack_public_path__ + "static/media/RupeesSign.5fb9b7df40977d3a62c0bb4dfd7e8f44.svg";
export { ForwardRef as ReactComponent };